<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Add Transaction'"
      [canGoBack]="true"
      [noBow]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form">
    <tidy-wrapper [class]="isRightSideContent ? 'finance-skeleton right-side-scroll-enabled' : 'finance-skeleton'">
      @if (!loaded) {
        @for (i of [1,2,3,4,5,6]; track i) {
          <ion-skeleton-text [animated]="true" style="width: 100%; height: 44px; border-radius: 8px; margin-bottom: 12px;" />
        }
        <ion-skeleton-text [animated]="true" style="width: 100%; height: 48px; border-radius: 24px; margin-top: 8px;" />
      }
      @if (loaded) {
        <tidy-row>
          <tidy-datepicker
            [label]="'Date'"
            formControlName="date"
            [form]="form.controls.date"
            [submitted]="submitted"
            [errorMessage]="'Please select a date'" />
        </tidy-row>
        <tidy-row>
          <tidy-select
            [label]="'Spread'"
            formControlName="spread"
            [form]="form.controls.spread"
            [items]="spreadItems"
            [hideSearch]="true"
            [icon]="'assets/svg/calendar-outline.svg'" />
        </tidy-row>
        @if (form.controls.spread.value === 'custom') {
          <tidy-row>
            <tidy-datepicker
              [label]="'Last day it covers'"
              formControlName="spread_end"
              [form]="form.controls.spread_end"
              [minDate]="form.controls.date.value"
              [submitted]="submitted"
              [errorMessage]="'Pick a last day on or after the date'" />
          </tidy-row>
        }
        @if (spreadSummary) {
          <tidy-row class="txn-field-help">
            <tidy-text
              [helper]="spreadSummary"
              [translate]="false" />
          </tidy-row>
        }
        <tidy-row>
          <tidy-datepicker
            [label]="'Paid on (optional)'"
            formControlName="transacted_on"
            [form]="form.controls.transacted_on"
            [placeholder]="'Same as the date'"
            [icon]="'assets/svg/cash-outline.svg'" />
        </tidy-row>
        <tidy-row class="txn-field-help">
          <tidy-text [helper]="'Cash counts the whole amount in the month it was paid.'" />
        </tidy-row>
        <tidy-row>
          <tidy-input
            [label]="'Amount'"
            formControlName="amount"
            [form]="form.controls.amount"
            [icon]="'assets/svg/cash-outline.svg'"
            [submitted]="submitted"
            [errorMessage]="'Please enter a valid amount'"
            [type]="'number'" />
        </tidy-row>
        <tidy-row>
          <tidy-select
            [label]="'Transaction Type'"
            formControlName="transaction_type"
            [form]="form.controls.transaction_type"
            [items]="transactionTypes"
            [hideSearch]="true"
            [icon]="'assets/svg/swap-horizontal-outline.svg'" />
        </tidy-row>
        <tidy-row>
          <tidy-select
            [label]="'Category'"
            formControlName="monthly_finance_type_key"
            [form]="form.controls.monthly_finance_type_key"
            [items]="categoryItems"
            [icon]="'assets/svg/list-outline.svg'"
            [submitted]="submitted"
            [errorMessage]="'Please select a category'" />
        </tidy-row>
        <tidy-row>
          <tidy-select
            [label]="'Property'"
            formControlName="address_id"
            [form]="form.controls.address_id"
            [items]="propertyItems"
            [icon]="'assets/svg/home-outline.svg'"
            [submitted]="submitted"
            [errorMessage]="'Please select a property'" />
        </tidy-row>
        <tidy-row>
          <tidy-textarea
            [label]="'Description'"
            formControlName="description"
            [form]="form.controls.description"
            [icon]="'assets/svg/create-outline.svg'"
            [submitted]="submitted"
            [errorMessage]="'Please enter a description'" />
        </tidy-row>

        <tidy-error-message
          [text]="errorMessage" />

        <tidy-button
          [text]="'Add Transaction'"
          [action]="boundSave"
          [disabled]="saving"
          class="primary" />
      }
    </tidy-wrapper>
  </form>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
